import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetTopconditionDetails = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_TOP_CONDITION_DETAILS, token);
  return res;
};

export const GetTopcondition = async (Id) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_TOP_CONDITION_DETAILS_BY_ID + Id, token);
  return res;
};

export const AddTopcondition = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_TOP_CONDITION, payload, token);
  return res;
};

export const DeleteTopcondition = async (Id) => {
  const token = localStorage.getItem("token");
  let res = await Services.DELETE(Url.DELETE_TOP_CONDITION + Id, Id, token);
  return res;
};

export const UpdateTopcondition = async (Id, payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.PUT(Url.UPDATE_TOP_CONDITION + Id, payload, token);
  return res;
};
